<template>
    <!-- <TopNav /> -->
    <nav-bar />
</template>

<script>
import NavBar from "./NavBar.vue";
import TopNav from "./TopNav.vue";
export default {
    components: {
        TopNav,
        NavBar,
    },
};
</script>

<style></style>
